import * as React from 'react';

import { action, computed, observable, runInAction } from 'mobx';
import { Provider, observer } from 'mobx-react';

import Feature from 'tm3-core/controls/feature';
import PayFeatures from 'tm3-pay/features';

import { ConfigObservable } from 'bz-stores/lib/config';

import $ from 'jquery';
import FeaturesStore from 'tm3-core/stores/feature-store';
import SquareStore from 'tm3-pay/stores/square-store';

interface IProps {
  children: React.ReactNode | React.ReactNodeArray;
}

@observer
class SquareWrapper extends React.Component<IProps> {
  @observable hasSquareLoaded: boolean = false;
  @observable isSquareLoading: boolean = false;
  @observable squareStore: SquareStore;
  render() {
    if (
      !this.hasSquareLoaded &&
      !this.isSquareLoading &&
      !!ConfigObservable.config &&
      !!this.applicationId &&
      !!FeaturesStore.square
    ) {
      this.loadScript(); // naughty but not directly mutating -- copied from stripe as that seems to work
      return this.props.children;
    }

    if (!this.hasSquareLoaded || this.isSquareLoading) {
      return this.props.children;
    }

    return (
      <Feature value={PayFeatures.Square} fallback={this.props.children}>
        <Provider squareStore={this.squareStore}>{this.props.children}</Provider>
      </Feature>
    );
  }

  @computed
  private get applicationId(): string {
    const { config } = ConfigObservable;
    return !!config && config.TM3_PAYMENTS_SQUARE_APPLICATION_ID;
  }

  @computed
  private get isSandboxMode(): boolean {
    const { config } = ConfigObservable;
    return !!config && config.SQUARE_SANDBOX_MODE;
  }

  @computed
  private get scriptUrl(): string {
    // may need to be moved to app config
    return this.isSandboxMode
      ? 'https://sandbox.web.squarecdn.com/v1/square.js'
      : 'https://web.squarecdn.com/v1/square.js';
  }

  @action.bound
  private async loadScript(): Promise<void> {
    this.isSquareLoading = true;
    try {
      await $.getScript(this.scriptUrl);
      runInAction(() => {
        if (!!this.applicationId && !!FeaturesStore.square) {
          this.hasSquareLoaded = true;
          this.squareStore = new SquareStore(this.applicationId);
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.isSquareLoading = false;
    }
  }
}

export default SquareWrapper;
